import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environment/environment';
import { map, catchError } from 'rxjs/operators';

@Injectable()
export class WishService {
    constructor(private httpClient: HttpClient) { }

    // tous les wishes pour un utilisateur donné
    getWishesById(userId) {
        return this.httpClient
            .post<any>(`${environment.apiEndPoint}wishes/read`, JSON.stringify({ utilisateur_id: `${userId}` }))
            .pipe(
                map(res => res ? res.document.records as any[] : []),
                catchError(this.handleError)
            );
    }

    // creation wish
    createWish(domaineId, userId) {
        return this.httpClient
            .post<any>(`${environment.apiEndPoint}wish/create`,
                JSON.stringify({ domaine_id: `${domaineId}`, utilisateur_id: `${userId}` })
            )
            .pipe(
                map(res => res.document),
                catchError(this.handleError)
            );
    }

    deleteWish(domaineId, userId) {
        return this.httpClient
            .post(`${environment.apiEndPoint}wish/delete`,
                JSON.stringify({ domaine_id: `${domaineId}`, utilisateur_id: `${userId}` })
            )
            .pipe(
                map(res => res),
                catchError(this.handleError)
            );
    }

    private handleError(error: any): Promise<any> {
        let retour = error?.error?.message || error?.message || error;
        if(error?.error?.data) retour += '<br />'+error?.error?.data;
        return Promise.reject(retour);
    }
}